// extracted by mini-css-extract-plugin
export default {"window-wrapper":"AkrWR96wdS7YMQrXrwU7","windowWrapper":"AkrWR96wdS7YMQrXrwU7","dock-wrapper":"pW8Hypf2Cm2JKPEIQgA2","dockWrapper":"pW8Hypf2Cm2JKPEIQgA2","fps":"m3GNYDTDiNirl2_zim3Q"};